import React from 'react';

const Icon = ({ icon }) => {
  return <i className={icon}></i>;
};

export default Icon;
